<template>
  <section class="p1 banners section">
    <div class="section-content">
      <el-carousel height="40vw" style="width: 100%;" :autoplay="false" indicator-position="none">
        <el-carousel-item>
            <div class="image-wrapper">
              <img src="../../assets/images/home/banner-0.jpg"/>
            </div>
           <!-- 节日氛围图  -->
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner banner-1">
            <div class="image-wrapper">
              <img src="../../assets/images/home/banner-1.jpg"/>
            </div>
            <div class="title-wrapper">
              <div class="title">
                <div class="p-1-1">
                  <span>{{$t('HomeText.p1_1_1')}}</span><span>{{$t('HomeText.p1_1_1_2')}}</span>
                </div>
                <div class="p-1-2">
                  <span>{{$t('HomeText.p1_1_2')}}</span>
                </div>
                <div class="p-1-3">
                  <span>{{$t('HomeText.p1_1_3')}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner banner-2">
            <div class="image-wrapper">
              <img src="../../assets/images/home/banner-2.jpg"/>
            </div>
            <div class="title-wrapper">
              <div class="title">
                <div class="p-2-1">
                  <span>{{$t('HomeText.p1_2_1')}}</span>
                  <span>{{$t('HomeText.p1_2_1_2')}}</span>
                </div>
                <div class="p-2-2">
                  <span>{{$t('HomeText.p1_2_2')}}</span>
                </div>
                <div class="p-2-3">
                  <span>{{$t('HomeText.p1_2_3')}}</span><span>{{$t('HomeText.p1_2_3_2')}}</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner banner-3">
            <div class="image-wrapper">
              <img src="../../assets/images/home/banner-3.jpg"/>
            </div>
            <div class="title-wrapper">
              <div class="title">
                <img class="bg-1" src="../../assets/images/home/banner-3-1.png"/>
                <img class="bg-2" src="../../assets/images/home/banner-3-2.png"/>
                <div class="title-box">
                  <span class="cn">{{$t('HomeText.p1_3_1')}}</span>
                  <span class="en">Professional</span>
                </div>
                <div class="title-box">
                  <span class="cn">{{$t('HomeText.p1_3_2')}}</span>
                  <span class="en">Efficient</span>
                </div>
                <div class="title-box">
                  <span class="cn">{{$t('HomeText.p1_3_3')}}</span>
                  <span class="en">Precise</span>
                </div>
                <div class="title-box">
                  <span class="cn">{{$t('HomeText.p1_3_4')}}</span>
                  <span class="en">High Quality</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </section>
</template>

<script>
  export default {
    name: "p1-banner",
  }
</script>

<style lang="scss">
  .en .v-home{
    .p1.banners {
      .banner-1 {
        .title {
          .p-1-1 {
            span:last-child {
              margin-top: -12px;
              display: block;
            }
          }
        }
      }

      .banner-2 {
        .title-wrapper {
          top: 18vw;
        }

        .title {

          .p-2-1 {
            font-size: 2.6vw;

            span:last-child {
              display: block;
            }
          }

          .p-2-3 {
            font-size: 2.6vw;

            span:last-child {
              display: block;
            }
          }
        }
      }
    }
  }

  .p1.banners {

    background-color: #ffffff;
    width: 100%;

    .section-content {
      width: 100%;
      position: relative;
    }

    .banner {
      width: 100%;
      position: relative;

      .image-wrapper {
        width: 100%;
        height: 40vw;
      }

      .title-wrapper {
        position: absolute;
      }
    }

    .banner-1 {
      .title-wrapper {
        left: 12vw;
        top: 12vw;
      }

      .title {
        font-weight: bold;
        color: #2cacab;
        font-size: 3.13vw;

        .p-1-1 {
          :first-child {
            font-size: 5.2vw;
            line-height: 3.65vw;
          }

          :last-child {
            font-size: 3.13vw;
            line-height: 3.65vw;
          }
        }

        .p-1-2 {
          margin: 1vw 0 1vw;
          padding-right: 1vw;
          color: #ffffff;
          display: inline-block;
          position: relative;
          background: url('../../assets/images/home/banner-1-2-bg-3.png');
          background-size: 100% 100%;

          span {
            padding: .2vw 3vw .2vw 1vw;
            width: 100%;
            height: 100%;
            background: url('../../assets/images/home/banner-1-2-bg-2.png');
            background-size: 100% 100%;
          }
        }

        .p-1-3 {
          line-height: 4.07vw;
          color: #4e4e4e;
        }
      }
    }

    .banner-2 {
      .title-wrapper {
        right: 5vw;
        top: 20vw;
      }

      .title {
        font-weight: bold;

        .p-2-1 {
          color: #1ca1a0;
          font-size: 4.17vw;
        }

        .p-2-2 {
          margin: .5vw 0 .5vw;
          font-size: 3.13vw;
          padding-right: 1vw;
          color: #ffffff;
          display: inline-block;
          position: relative;
          background: url('../../assets/images/home/banner-1-2-bg-3.png');
          background-size: 100% 100%;

          span {
            padding: .2vw 3vw .2vw 1vw;
            width: 100%;
            height: 100%;
            background: url('../../assets/images/home/banner-1-2-bg-2.png');
            background-size: 100% 100%;
          }
        }

        .p-2-3 {
          font-size: 3.13vw;
          color: #4e4e4e;
        }
      }
    }

    .banner-3 {
      .title-wrapper {
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .title {
        font-weight: bold;
        display: flex;
        position: relative;

        .bg-1 {
          position: absolute;
          left: -1.3vw;
          top: -3vw;
          width: 12.6vw;
          height: 8.23vw;
          opacity: 0.86;
        }

        .bg-2 {
          position: absolute;
          right: 0;
          bottom: -1vw;
          width: 6.25vw;
          height: 4.06vw;
          opacity: 0.86;
        }

        .title-box {
          z-index: 1;
          display: flex;
          flex-flow: column;
          align-items: center;
          margin-right: 2.5vw;

          .cn {
            font-size: 4.17vw;
            line-height: 1;
            font-style: italic;
            color: #ffffff;
          }

          .en {
            font-size: 1.77vw;
            color: #c9c9c9;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home/p1-banner.vue